/* eslint no-unused-vars: 0 */

var $ = require('jquery');
var _ = require('lodash');
var csrftoken = require('common/csrftoken');
var bs4css = require('scss/_custom.scss');
var bootstrap = require('bootstrap/dist/js/bootstrap.js');
var nouisliderCSS = require('nouislider/jquery.nouislider.css');
var select2css = require('select2/select2.css');
var multiselectcss = require('bootstrap-multiselect/dist/css/bootstrap-multiselect.css');
var blueimp = require('blueimp-gallery/js/jquery.blueimp-gallery.js');
var blueimpCSS = require('blueimp-gallery/css/blueimp-gallery.css');
var profilesCSS = require('scss/styles-casting.scss');
var profilesCSS = require('scss/styles-profile.scss');
var React = require('react');
var ReactDOM = require('react-dom');
var { createStore, combineReducers, applyMiddleware } = require('redux');
var { Provider } = require('react-redux');
var ReduxThunk = require('redux-thunk').default;
var router = require('react-router');
var { syncHistoryWithStore, routerReducer, routerMiddleware } = require('react-router-redux');
var { queryStringToJSON } = require('common/api/query');
var { TalentProfileApp } = require('./components/app');
var { ProfileDetails } = require('./components/details/details');
var { ProfileMedia } = require('./components/media/media');
var { ProfileHighlights } = require('./components/highlights/highlights');
var { appearance } = require('./reducers/appearance');
var { meta } = require('./reducers/meta');
var { media } = require('./reducers/media');
var { skills } = require('./reducers/skills');
var { education } = require('./reducers/education');
var { credits } = require('./reducers/credits');
var { representation } = require('./reducers/representation');
var { highlights } = require('./reducers/highlights');
var { links } = require('./reducers/links');
var { user } = require('common/reducers/user');
var constants = require('./constants');
var { Header } = require('header/components/header');


// All changes to state will happen inside the following redcucers
var reducers = combineReducers({
  meta, user, appearance, media, skills,
  education, representation, links,
  credits, highlights, routing: routerReducer
});

// ReduxThunk - to dispatch async actions
// routerMiddleware - to dispatch router navigation actions
var middleware = applyMiddleware(ReduxThunk, routerMiddleware(router.browserHistory));

// Setup the redux store.
var initialState = {};
var store = createStore(reducers, initialState, middleware);

// Create an enhanced history that syncs navigation events with the store
var history = syncHistoryWithStore(router.browserHistory, store);
// How do I watch for navigation events, such as for analytics?
// history.listen(location => analyticsService.track(location.pathname))

// global listener for "working" progress indicator

$(document)
  .ajaxStart(() => $('.loading').show())
  .ajaxStop(() => $('.loading').hide())
  .ready(() => {
    $('.close-beta-notice').click((e) => {
      e.preventDefault();
      $('.beta-notice').hide();
    });

    window._kmq = window._kmq || [];
    if (window.kmqAnalytics) {
      window._kmq.push(['identify', window.kmqAnalytics.user_email]);
      window._kmq.push(['set', window.kmqAnalytics]);
    }
  });

// Yes, we have two different rendering trees. the header is not part of the app heirarchy
ReactDOM.render(<Header />, document.getElementById('header__container'));

function getRoutesForBasePath(basePath) {
  return (
    <router.Route path={basePath}>
      <router.IndexRoute component={ProfileDetails} />
      <router.Route path="media">
        <router.IndexRoute component={ProfileMedia} filter="all" />
        <router.Route path="audio" component={ProfileMedia} filter="audio" />
        <router.Route path="videos" component={ProfileMedia} filter="videos" />
        <router.Route path="documents" component={ProfileMedia} filter="documents" />
        <router.Route path="photos" component={ProfileMedia} filter="photos" />
      </router.Route>
      <router.Route path="about" component={ProfileHighlights} />
    </router.Route>
  );
}

ReactDOM.render((
  <Provider store={store}>
    <router.Router history={history}>
      <router.Route path="/" component={TalentProfileApp}>
        {getRoutesForBasePath('profile')}
        {getRoutesForBasePath('u/:slug')}
      </router.Route>
    </router.Router>
  </Provider>
), document.getElementById('app__container'));



// WEBPACK FOOTER //
// ./bso/frontend/static/js/talent_profiles/index.js